export default {
	props: {
		es_id: Number,
		price: Number,
		value:{type:Number, default: 0},
		isPerPerson: Boolean,
		maxPersons: Number,
	},
	data(){
		return {
			selected_qty: 0,
		}
	},
	watch:{
		value:{
			immediate: true,
			handler(){
				let tmp = typeof(this.value)!=='undefined'&&this.value!==null ? this.value : 0;
				if(this.selected_qty!==tmp){
					this.selected_qty = tmp;
				}
			},
		},
		selected_qty:{
			handler(){
				let data = {es_id:this.es_id, price:this.price, qty:this.selected_qty};
				this.$emit('change', data);
			},
		}
	},
	computed:{
		cp_options(){
			let res = [];
			if(this.isPerPerson){
				for (let i=1; i<=this.maxPersons; i++) {
					res.push({label:i, value:i});
				}
			} else {
				res.push({label:this.$t('Yes'), value:1});
			}
			return res;
		},
	},
	template: `
<div style="display:flex;align-items:center;">
	<span style="margin-right:5px;">x</span>
	<qit-select
		class="w-100 v3"
		:label="$t('selectOption')"
		:label-value="0"
		:options="cp_options"
		clearable
		v-model="selected_qty"
	></qit-select>
</div>
`,
}
